import * as actionTypes from "./actionTypes";

export const submitEmployeeAction = (employeeData) => {
  return { type: actionTypes.SUBMIT_EMPLOYEE, employeeData };
};

export const submitEmployeeSuccessAction = (employees) => {
  return { type: actionTypes.SUBMIT_EMPLOYEE_SUCCESS, employees };
};
export const getEmployeeDetailsAction = (storeId) => {
  return { type: actionTypes.GET_EMPLOYEE_DETAILS, storeId };
};

export const getEmployeeDetailsSuccessAction = (employees) => {
  return { type: actionTypes.GET_EMPLOYEE_DETAILS_SUCCESS, employees };
};

export const editEmployeeAction = (employee) => {
  return { type: actionTypes.EDIT_EMPLOYEE, employee };
};

export const editEmployeeSuccessAction = (employees) => {
  return { type: actionTypes.EDIT_EMPLOYEE_SUCCESS, employees };
};

export const deleteEmployeeAction = (employee) => {
  return { type: actionTypes.DELETE_EMPLOYEE, employee };
};

export const deleteEmployeeSuccessAction = (employees) => {
  return { type: actionTypes.DELETE_EMPLOYEE_SUCCESS, employees };
};
